import { createFileRoute } from "@tanstack/react-router";
import JwtDebuggerPage from "@/pages/JwtDebuggerPage";

export const Route = createFileRoute("/tools/jwt-debugger")({
  component: JwtDebuggerPage,
});
